import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, STUDIO_IMAGE } from "../data/site";

export default function Services() {
  const [active, setActive] = useState(0);
  const activeImage = SERVICES[active].image || STUDIO_IMAGE;

  return (
    <section id="services" data-testid="services-section" className="bg-cream text-ink py-24 md:py-32 px-5 md:px-10 lg:px-16 relative overflow-hidden">
      <div className="grid grid-cols-12 gap-6 mb-16 items-end">
        <div className="col-span-12 md:col-span-8">
          <div className="inline-flex items-center gap-2 bg-ink text-cream rounded-full px-4 py-2 mb-6">
            <span className="font-body text-xs tracking-widest uppercase">O que fazemos</span>
          </div>
          <h2 className="font-display font-extrabold text-5xl md:text-7xl lg:text-8xl leading-[0.92] text-ink">
            oito capítulos.
            <br />uma <span className="bg-lime px-3 italic rounded-2xl inline-block">missão</span>.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4">
          <p className="font-body text-base text-ink/70 leading-relaxed">
            Do primeiro take ao booking — cobrimos cada etapa com a mesma obsessão pelos detalhes.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-8 items-start">
        <ul className="col-span-12 md:col-span-7 space-y-3">
          {SERVICES.map((s, i) => (
            <li
              key={s.id}
              data-testid={`service-item-${s.id}`}
              onMouseEnter={() => setActive(i)}
              className={`group grid grid-cols-12 gap-4 p-6 rounded-3xl cursor-default border-2 transition-all ${
                active === i ? "bg-ink text-cream border-ink" : "bg-transparent text-ink border-ink/10 hover:border-ink"
              }`}
            >
              <span className={`col-span-2 md:col-span-1 font-body text-sm font-bold ${active === i ? "text-lime" : "text-ink/40"}`}>
                {s.number}
              </span>
              <div className="col-span-8 md:col-span-9">
                <h3 className="font-display font-extrabold text-2xl md:text-3xl leading-tight flex items-center gap-3">
                  {s.title}
                  <ArrowUpRight size={22} className={`transition-all ${active === i ? "opacity-100 translate-x-1 -translate-y-1" : "opacity-40"}`} />
                </h3>
                <p className="font-body text-sm opacity-80 mt-2 max-w-md">{s.description}</p>
              </div>
              <span className={`col-span-2 font-body text-[10px] uppercase tracking-widest text-right self-center ${active === i ? "text-cream/60" : "text-ink/40"}`}>
                {s.duration}
              </span>
            </li>
          ))}
        </ul>

        <div className="col-span-12 md:col-span-5 lg:sticky lg:top-28">
          <div className="relative aspect-[4/5] w-full rounded-3xl overflow-hidden border-2 border-ink/10">
            <AnimatePresence mode="wait">
              <motion.img
                key={active}
                src={activeImage}
                alt={SERVICES[active].title}
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </AnimatePresence>
            <div className="absolute top-4 left-4 bg-lime text-ink font-display font-black px-3 py-1 rounded-full text-xs">
              {SERVICES[active].number} / {SERVICES[active].title}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
